import UserActionEventObject from './user-action-event-object';
import NonInteractiveEventObject from './non-interactive-event-object';
import ProductClickObject from './product-click-object';
import ProductImpressionObject from './product-impression-object';
import ProductDetailObject from './product-detail-object';
import PromotionClickObject from './promotion-click-object';
import PromotionImpressionObject from './promotion-impression-object';

/**
 * types
 * List of allowed data types
 * @type {object}
 * @member AnalyticsHandler#types
 */
export const TAGGING_TYPES = {
  productClick: ProductClickObject,
  productImpression: ProductImpressionObject,
  productDetail: ProductDetailObject,
  userActionEvent: UserActionEventObject,
  nonInteractiveEvent: NonInteractiveEventObject,
  promotionClick: PromotionClickObject,
  promotionImpression: PromotionImpressionObject,
};

/**
 * Whitelist of types of Analytics events.
 */
export const TAGGING_TYPES_ARRAY = Object.keys(TAGGING_TYPES);

/**
 *
 * @param type
 * @returns {boolean}
 */
export const hasTaggingType = (type) =>
  TAGGING_TYPES_ARRAY.map((o) => o.toLowerCase()).indexOf(type.toLowerCase()) > -1;
